const LABEL_ADMINS_TABLE = {
  columns: [
    {
      label: 'admins.full_name_header',
      field: 'firstName,lastName',
      getValue: (raw) => {
        if (raw.firstName && raw.lastName) {
          return raw.firstName + ' ' + raw.lastName
        } else {
          return '';
        }
      },
      ordering: true
    },
    {
      label: 'admins.email_header',
      field: 'email',
      getValue: (raw) => {
        return raw.email
      },
      ordering: true
    },
    {
      label: 'admins.created_at_header',
      field: 'createdAt',
      getValue: (raw) => {
        return raw.createdAt
      },
      ordering: true
    },
    {
      label: 'admins.status_header',
      field: 'status',
      ordering: false,
      translate: true,
      getValue(raw) {
        return 'admin_status.' + raw.status;
      }
    },
  ]
}

export default LABEL_ADMINS_TABLE;
